import { Component, EventEmitter, Output, input } from '@angular/core';
import { SharedModule } from 'src/app/core/shared.module';
import { buttonStyles } from './button.variants';

export type VButtonV2Variant = 'primary' | 'ghost' | 'outline';

@Component({
  selector: 'v-button-v2',
  imports: [SharedModule],
  template: `<button
    [type]="type()"
    [class]="classNames"
    [disabled]="disabled() || loading()"
    [attr.data-testid]="testId()"
    (click)="press.emit($event)">
    @if (icon() && !loading()) {
      <i [class]="icon()"></i>
    }
    @if (loading()) {
      <i class="pi pi-spin pi-spinner"></i>
    }
    <ng-content></ng-content>
  </button>`,
})
export class VButtonV2Component {
  /**
   * Which variant to use
   */
  readonly variant = input<VButtonV2Variant>('primary');

  readonly size = input<'sm' | 'md' | 'lg'>('md');

  readonly type = input<'button' | 'submit'>('button');

  readonly fullWidth = input(false);

  /**
   * Optional icon to display
   */
  readonly icon = input('');

  /**
   * Whether the button is disabled
   */
  readonly disabled = input(false);

  /**
   * Whether the button should display a loading indicator
   */
  readonly loading = input(false);

  /**
   * Optionally sets the test id for the button
   */
  readonly testId = input<string>();

  /**
   * Optional click handler
   */
  @Output()
  press = new EventEmitter<Event>();

  get classNames(): string {
    return buttonStyles({
      size: this.size(),
      variant: this.variant(),
      fullWidth: this.fullWidth(),
    });
  }
}
